import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { describirFiltros, type FiltrosCuadro } from '@/lib/cuadro/filtros';

// Cabecera que solo existe en papel (change 003, D6). En el PDF no hay selector de
// periodo ni chips de filtro, así que lo que se está mirando tiene que decirse con
// palabras: un informe sin su contexto no se puede interpretar fuera de la pantalla.

const ddmmaaaa = (dia: string) => dia.split('-').reverse().join('/');

const AHORA = new Intl.DateTimeFormat('es-ES', {
  timeZone: 'Europe/Madrid',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function CabeceraImpresion({
  diaDesde,
  diaHasta,
  filtros,
  razonSocialCliente,
  total,
}: {
  diaDesde: string;
  diaHasta: string;
  filtros: FiltrosCuadro;
  razonSocialCliente: string | null;
  total: number;
}) {
  const filtrosActivos = describirFiltros(filtros, razonSocialCliente);
  // La hora es la de IMPRIMIR, no la de pintar la página: el cuadro se queda abierto
  // horas y un informe con la hora de la mañana diría algo falso. `flushSync` para
  // que el cambio esté en el DOM antes de que el navegador haga la foto.
  const [generado, setGenerado] = useState(() => new Date());
  useEffect(() => {
    const alImprimir = () => flushSync(() => setGenerado(new Date()));
    window.addEventListener('beforeprint', alImprimir);
    return () => window.removeEventListener('beforeprint', alImprimir);
  }, []);
  return (
    <div
      data-testid="cabecera-impresion"
      className="mb-4 hidden border-b border-[var(--border)] pb-3 print:block"
    >
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="m-0 text-[16px] font-semibold text-[var(--navy)]">
          Aramática · Resumen del servicio
        </h2>
        <span className="mono text-[11px] text-[var(--text-dim)]">
          Generado el {AHORA.format(generado)}
        </span>
      </div>
      {/* El total va dentro de la frase y no en un elemento propio: esta cabecera
          está oculta en pantalla, y un «6» suelto se confunde con el KPI para
          quien busque ese número en la página (le pasó al e2e 009). */}
      <p className="m-0 mt-1 text-[12.5px] tabular-nums text-[var(--text-2)]">
        {`Llamadas del ${ddmmaaaa(diaDesde)} al ${ddmmaaaa(diaHasta)} · ${total.toLocaleString('es-ES')} en total`}
      </p>
      <p className="m-0 mt-0.5 text-[12px] text-[var(--text-dim)]">
        {filtrosActivos.length > 0 ? filtrosActivos.join(' · ') : 'Sin filtros'}
      </p>
    </div>
  );
}
